import { HttpClient, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { CrudBaseService } from '../crud.service';
import { EventLog } from '../models/event-log';

export class HttpCallModel {
  request: HttpRequest<any>;
  error: HttpErrorResponse;
}

@Injectable()
export class ErrorLogService extends CrudBaseService<any>  {

  private startLogSource$ = new Subject<HttpCallModel>();
  constructor(protected httpClient: HttpClient) {
    super('/event_log', httpClient);
    this.startLogSource$.pipe(switchMap((errDescription) => this.logError(errDescription))).subscribe();
  }

  startLogging(data: HttpCallModel): void {
    this.startLogSource$.next(data);
  }

  logError(errorDescription: HttpCallModel): Observable<EventLog> {
    const errorObj = {
      method: errorDescription?.request?.method,
      payload: errorDescription?.request.body?.data,
      url: errorDescription?.error?.url,
      urlWithParams: errorDescription?.request?.urlWithParams,
      errorBody: errorDescription?.error?.error,
      status: errorDescription?.error?.status
    };
    if (errorDescription.request.body instanceof File) {
      errorObj.payload = {
        fileType: errorDescription?.request?.body.type,
        fileSize: errorDescription?.request?.body.size
      };
    };

    return this.httpClient.post(`${this.basePath}`, {
      data: {
        description: JSON.stringify(errorObj)
      }
    });
  }
}
